import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNotify } from "react-admin";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { selectCustomer, selectCurationGroupId } from "./reducer";
import { reqCurationCopy } from "./api";
import { presentToYyyyMmDd } from "../util/date";
import { Box, Typography } from "@mui/material";

const CurationCopyDialog = ({ open, week, onClose }) => {
  const notify = useNotify();

  // customerId
  const customer = useSelector(selectCustomer);

  // curationGroupId
  const curationGroupId = useSelector(selectCurationGroupId);

  const firstDate = presentToYyyyMmDd(week[0]);
  const lastDate = presentToYyyyMmDd(week[6]);

  // loading state
  const [loading, setLoading] = useState(false);
  // overwrite error state
  const [hasOverwriteErr, setHasOverwriteErr] = useState(false);

  const handleCurationCopy = async (needOverwrite = false) => {
    try {
      setLoading(true);

      const curationCopyData = {
        curationGroupId,
        customerId: customer.id,
        dateFrom: firstDate,
        dateTo: lastDate,
        overWrite: needOverwrite, //overwrite 아니고 over'W'rite
      };

      await reqCurationCopy(curationCopyData);

      doActionAfterCopySuccess();
    } catch (err) {
      // const needAskOverwrite = err.body.message.statusCode === 409;
      const needAskOverwrite = err.body.statusCode === 409;

      if (needAskOverwrite) {
        setHasOverwriteErr(true);
      } else {
        doActionAfterError400(err);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseCurationCopyDialog = () => {
    onClose();

    // 다이얼로그 닫히는 순간에 초기화된 state가 보여서 0.2초 setTimeout 해줌
    setTimeout(() => {
      setHasOverwriteErr(false);
    }, 200);
  };

  const doActionAfterCopySuccess = () => {
    onClose();
    notify("내보내기 성공! 🎉🎉🎉🎉", "success");
    setHasOverwriteErr(false);
  };

  const doActionAfterError400 = (err) => {
    onClose();
    notify(
      `내보내기에 실패했습니다. 😭 [오류: ${err.body.message.message}] (code: ${err.body.message.statusCode})`,
      "error"
    );
    setHasOverwriteErr(false);
  };

  useEffect(() => {
    return () => {
      setHasOverwriteErr(false);
    };
  }, []);

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      onClose={handleCloseCurationCopyDialog}
    >
      <DialogTitle id="alert-dialog-title">
        {hasOverwriteErr ? `앗..!` : `메뉴 내보내기`}
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            textAlign: "center",
            marginBottom: 1,
          }}
        >
          {hasOverwriteErr ? (
            <img src="/foodang_crying.png" width="120" alt="우는 푸댕이" />
          ) : (
            <img src="/cyberfoodang.png" width="120" alt="푸댕이" />
          )}
        </Box>

        {hasOverwriteErr ? (
          <div>
            <Typography>
              다른 고객사에 이미 저장된 메뉴 큐레이션이 있습니다..
              <br />
              새로운 메뉴 큐레이션으로 덮어쓰시겠습니까?
            </Typography>
          </div>
        ) : (
          <div>
            <Typography>
              {firstDate} 부터 {lastDate} 까지의 메뉴들을
              <br />
              <Typography
                component="span"
                sx={{ bgcolor: "beige", marginRight: 0.5 }}
              >
                {curationGroupId}번
              </Typography>
              큐레이션 그룹의 다른 고객사에 내보냅니다!
            </Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseCurationCopyDialog} disabled={loading}>
          취소
        </Button>
        <Button
          onClick={() => {
            if (hasOverwriteErr) {
              handleCurationCopy(true);
            } else {
              handleCurationCopy();
            }
          }}
          disabled={loading}
          color="primary"
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CurationCopyDialog;
